/**
 * Component: Product Sharing
 * ------------------------------------------------------------------------------
 * Controls the sharing functionality of the product page.
 *
 * @namespace productSharing
 */
import log from 'salvo-lite/log'
import {on} from '../helpers/utils'
import cssClasses from '../helpers/cssClasses'

class ProductSharing {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            buttonCopy: '[data-sharing-text]',
            urlContainer: '[data-sharing-url]',
            ...JSON.parse(elem.getAttribute('data-product-sharing') || '{}')
        }

        /**
         * DOM node selectors.
         */
        this._nodeSelectors = {
            urlContainer: document.querySelector(this._settings.urlContainer)
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
   * Initialize component.
   */
    onInit () {
        this._setTriggerEvents()
    }

    /**
     * Set trigger listeners on click.
     */
    _setTriggerEvents () {
        on('click', this._elem, (event) => this._shareUrl(event, this._elem))
    }

    /**
     * Get the input value of the page url so that it can be copied
     */
    _shareUrl (event, button) {
        event.preventDefault()
        const shareType = button.dataset.sharingType

        if (shareType === 'copy') {
            this._copyUrl(button)
        }
    }

    /**
     * Get page url and pass it to the clipboard.
     */
    _copyUrl (button) {
        const buttonCopy = button.querySelector(this._settings.buttonCopy)

        this._nodeSelectors.urlContainer.select()
        document.execCommand('copy')
        buttonCopy.innerText = window.theme.strings.copiedUrl
        button.classList.add(cssClasses.active)
        window.setTimeout(() => {
            button.classList.remove(cssClasses.active)
            buttonCopy.innerText = window.theme.strings.copyUrl
        }, 2000)
    }

    /**
     * Expose public interface.
     */
    // return Object.freeze({
    //     init,
    // });
}

export default ProductSharing



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductSharing.js